import { Tag } from "antd";
import { CheckableTagProps, TagProps } from "./type";

const { CheckableTag } = Tag;
function AntTag(props: TagProps) {
  return <Tag {...props} />;
}

function AntCheckableTag(props: CheckableTagProps) {
  return <CheckableTag {...props} />;
}

export { AntTag as Tags, AntCheckableTag as CheckableTags };
